export const settings = {
    "single":{
       "target":{
          "id":"diamond_s1",
          "width":473,
          "height":375
       },
       "server":{
          "url":"https://ion.r2net.com/",
          "tpl":4,
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "lSpeedN":8,
          "lSpeedT":3000,
          "preload":4,
          "simPreloadSets":4,
          "simSets":4,
          "lSimPreloadSets":4,
          "lSimSets":4,
          "dynamic":{
             
          }
       },
       "indicator":{
          "show":false,
          "NSpeedWd":7,
          "LSpeedWd":5,
          "accelK":1
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "LogoImages":",https://ion.r2net.com/Images/Watermark/Watermark4.png",
       "factor":1,
       "autoRotation":true,
       "zoom":true,
       "jsonp":true,
       "MaxSpeedK":1,
       "SlowDownK":1,
       "jsonpClbFnc":"jsonCBF_s1_512_473x375"
    },
    "LargeDiamond":{
       "target":{
          "id":"diamond_s3",
          "width":757,
          "height":600
       },
       "server":{
          "url":"https://ion.r2net.com/",
          "tpl":0,
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "lSpeedN":8,
          "lSpeedT":3000,
          "preload":4,
          "simPreloadSets":4,
          "simSets":4,
          "lSimPreloadSets":4,
          "lSimSets":4,
          "dynamic":{
             
          }
       },
       "indicator":{
          "show":true,
          "NSpeedWd":7,
          "LSpeedWd":5,
          "accelK":1
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "LogoImages":",https://ion.r2net.com/Images/Watermark/Watermark0.png",
       "factor":1,
       "autoRotation":true,
       "zoom":false,
       "jsonp":true,
       "MaxSpeedK":1,
       "SlowDownK":1
    },
    "StageSegoma":{
       "target":{
          "id":"SegomaItemCanvas",
          "width":473,
          "height":375
       },
       "server":{
          "url":"https://ion.r2net.com/",
          "tpl":4,
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "lSpeedN":8,
          "lSpeedT":3000,
          "preload":4,
          "simPreloadSets":4,
          "simSets":4,
          "lSimPreloadSets":4,
          "lSimSets":4,
          "dynamic":{
             
          }
       },
       "indicator":{
          "show":true,
          "NSpeedWd":7,
          "LSpeedWd":5,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "LogoImages":",https://ion.r2net.com/Images/Watermark/Watermark4.png",
       "factor":1,
       "autoRotation":true,
       "rotation":true,
       "zoom":true,
       "jsonp":true,
       "MaxSpeedK":1,
       "SlowDownK":1,
       "jsonpClbFnc":"jsonCBF_sis_512_473x375"
    },
    "ringItem":{
       "target":{
          "id":"ringCanvas",
          "width":473,
          "height":375
       },
       "server":{
          "url":"https://ion.r2net.com/",
          "folder":"",
          "fileMask":"set",
          "setExt":"",
          "setsNum":1,
          "preload":1
       },
       "indicator":{
          "show":false,
          "NSpeedWd":0,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":0.1,
       "autoRotation":true,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_Ring_473x375"
    },
    "BrioStage":{
       "target":{
          "id":"SegomaItemCanvas",
          "width":480,
          "height":380
       },
       "OneTurn":{
          "flagOn":true,
          "firstSlide":1,
          "lastSlide":128
       },
       "currentSlide":43,
       "server":{
          "url":"https://ion.r2net.com/",
          "folder":"",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":4,
          "lSpeedN":8,
          "lSpeedT":3000,
          "preload":4,
          "simPreloadSets":4,
          "simSets":4,
          "lSimPreloadSets":4,
          "lSimSets":4
       },
       "indicator":{
          "show":true,
          "NSpeedWd":4,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":0.5,
       "autoRotation":true,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_Ring_473x375_GPU8"
    },
    "ringItem128":{
       "target":{
          "id":"ringCanvas",
          "width":473,
          "height":375
       },
       "OneTurn":{
          "flagOn":true,
          "firstSlide":1,
          "lastSlide":128
       },
       "currentSlide":43,
       "server":{
          "url":"https://ion.r2net.com/",
          "folder":"",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":4,
          "preload":2
       },
       "indicator":{
          "show":true,
          "NSpeedWd":4,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":0.5,
       "autoRotation":false,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_Ring_473x375_GPU8"
    },
    "ringItem250":{
       "target":{
          "id":"ringCanvas",
          "width":473,
          "height":375
       },
       "currentSlide":1,
       "server":{
          "url":"https://ion.r2net.com/",
          "folder":"",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":6,
          "preload":2
       },
       "indicator":{
          "show":true,
          "NSpeedWd":6,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":0.5,
       "autoRotation":false,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_Ring_473x375_GPU8"
    },
    "diamondGallery":{
       "target":{
          "id":"",
          "width":303,
          "height":240
       },
       "server":{
          "tpl":3,
          "url":"six/",
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":1,
          "preload":1,
          "reloadTm":1000,
          "maxWaitT":10,
          "dynamic":{
             
          }
       },
       "switchToOver":true,
       "indicator":{
          "show":false,
          "NSpeedWd":0,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":false,
       "LogoImages":",https://ion.r2net.com/Images/Watermark/Watermark3.png",
       "factor":0.1,
       "autoRotation":false,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_six1_16_304x240_CAN"
    },
    "jewelGallery":{
       "target":{
          "id":"",
          "width":304,
          "height":240
       },
       "server":{
          "url":"six/",
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":1,
          "preload":1,
          "reloadTm":1000,
          "maxWaitT":10
       },
       "switchToOver":true,
       "indicator":{
          "show":false,
          "NSpeedWd":0,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":0.1,
       "autoRotation":false,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_six1_16_304x240_CAN"
    },
    "jewelGallery128":{
       "target":{
          "id":"",
          "width":304,
          "height":240
       },
       "OneTurn":{
          "flagOn":true,
          "firstSlide":0,
          "lastSlide":31
       },
       "currentSlide":11,
       "server":{
          "url":"six/",
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":1,
          "preload":1,
          "reloadTm":1000,
          "maxWaitT":10
       },
       "switchToOver":true,
       "indicator":{
          "show":false,
          "NSpeedWd":0,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":2,
       "autoRotation":false,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_304x240_GPU8"
    },
    "jewelGallery250":{
       "target":{
          "id":"",
          "width":304,
          "height":240
       },
       "OneTurn":{
          "flagOn":false,
          "firstSlide":0,
          "lastSlide":24
       },
       "currentSlide":1,
       "server":{
          "url":"six/",
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":1,
          "preload":1,
          "reloadTm":1000,
          "maxWaitT":10
       },
       "switchToOver":true,
       "indicator":{
          "show":false,
          "NSpeedWd":0,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":2,
       "autoRotation":false,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_304x240_GPU8"
    },
    "StageSegomaJewel":{
       "target":{
          "id":"SegomaItemCanvas",
          "width":473,
          "height":375
       },
       
       "server":{
          "url":"https://ion.r2net.com/",
          "tpl":4,
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "lSpeedN":8,
          "lSpeedT":3000,
          "preload":4,
          "simPreloadSets":4,
          "simSets":4,
          "lSimPreloadSets":4,
          "lSimSets":4,
          "dynamic":{
             
          }
       },
       "indicator":{
          "show":true,
          "NSpeedWd":7,
          "LSpeedWd":5,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "LogoImages":"",
       "factor":1,
       "autoRotation":true,
       "rotation":true,
       "zoom":false,
       "jsonp":true,
       "MaxSpeedK":1,
       "SlowDownK":1,
       "jsonpClbFnc":"jsonCBF_sis_512_473x375"
    },
    "StageSegomaSoldJewel":{
       "target":{
          "id":"SegomaItemCanvas",
          "width":630,
          "height":500
       },
       "server":{
          "url":"https://ion.r2net.com/",
          "tpl":4,
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "lSpeedN":8,
          "lSpeedT":3000,
          "preload":4,
          "simPreloadSets":4,
          "simSets":4,
          "lSimPreloadSets":4,
          "lSimSets":4,
          "dynamic":{
             
          }
       },
       "indicator":{
          "show":true,
          "NSpeedWd":7,
          "LSpeedWd":5,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "LogoImages":"",
       "factor":1,
       "autoRotation":true,
       "rotation":true,
       "zoom":false,
       "jsonp":true,
       "MaxSpeedK":1,
       "SlowDownK":1,
       "jsonpClbFnc":"jsonCBF_sis_512_473x375"
    },
    "BrioStage500":{
       "target":{
          "id":"SegomaItemCanvas",
          "width":630,
          "height":500
       },
       "OneTurn":{
          "flagOn":false,
          "firstSlide":1,
          "lastSlide":256
       },
       "currentSlide":43,
       "server":{
          "url":"https://ion.r2net.com/",
          "folder":"",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":8,
          "lSpeedN":8,
          "lSpeedT":3000,
          "preload":4,
          "simPreloadSets":4,
          "simSets":4,
          "lSimPreloadSets":4,
          "lSimSets":4
       },
       "indicator":{
          "show":true,
          "NSpeedWd":4,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":0.5,
       "autoRotation":true,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_Ring_473x375_GPU8"
    },
    "BrioStagePendant":{
       "target":{
          "id":"SegomaItemCanvas",
          "width":630,
          "height":500
       },
       "OneTurn":{
          "flagOn":false,
          "firstSlide":1,
          "lastSlide":256
       },
       "currentSlide":43,
       "server":{
          "url":"https://ion.r2net.com/",
          "folder":"",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":8,
          "lSpeedN":8,
          "lSpeedT":3000,
          "preload":4,
          "simPreloadSets":4,
          "simSets":4,
          "lSimPreloadSets":4,
          "lSimSets":4
       },
       "indicator":{
          "show":true,
          "NSpeedWd":4,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":0.5,
       "autoRotation":true,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_Ring_473x375_GPU8"
    },
    "BrioStageStud":{
       "target":{
          "id":"SegomaItemCanvas",
          "width":630,
          "height":500
       },
       "OneTurn":{
          "flagOn":false,
          "firstSlide":1,
          "lastSlide":256
       },
       "currentSlide":43,
       "server":{
          "url":"https://ion.r2net.com/",
          "folder":"",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":8,
          "lSpeedN":8,
          "lSpeedT":3000,
          "preload":4,
          "simPreloadSets":4,
          "simSets":4,
          "lSimPreloadSets":4,
          "lSimSets":4
       },
       "indicator":{
          "show":true,
          "NSpeedWd":4,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":0.5,
       "autoRotation":true,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_Ring_473x375_GPU8"
    },
    "BrioStage512Frames":{
       "target":{
          "id":"SegomaItemCanvas",
          "width":630,
          "height":500
       },
       "OneTurn":{
          "flagOn":false,
          "firstSlide":1,
          "lastSlide":256
       },
       "currentSlide":43,
       "server":{
          "url":"https://ion.r2net.com/",
          "folder":"",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":8,
          "lSpeedN":8,
          "lSpeedT":3000,
          "preload":4,
          "simPreloadSets":4,
          "simSets":4,
          "lSimPreloadSets":4,
          "lSimSets":4
       },
       "indicator":{
          "show":true,
          "NSpeedWd":4,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":0.5,
       "autoRotation":true,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_Ring_473x375_GPU8",
       "rateCounter":72
    },
    "BrioGalleryGpu2":{
       "target":{
          "id":"",
          "width":650,
          "height":650
       },
       "OneTurn":{
          "flagOn":false,
          "firstSlide":1,
          "lastSlide":256
       },
       "currentSlide":1,
       "server":{
          "url":"six/",
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":1,
          "preload":1,
          "reloadTm":1000,
          "maxWaitT":10
       },
       "switchToOver":true,
       "indicator":{
          "show":false,
          "NSpeedWd":0,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":2,
       "autoRotation":false,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_304x240_GPU8"
    },
    "SegomaJewelGallery":{
       "target":{
          "id":"",
          "width":304,
          "height":240
       },
       "server":{
          "url":"six/",
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "setsNum":1,
          "preload":1,
          "reloadTm":1000,
          "maxWaitT":10
       },
       "switchToOver":true,
       "indicator":{
          "show":false,
          "NSpeedWd":0,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":false,
       "factor":0.1,
       "autoRotation":false,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_six1_16_304x240_CAN"
    },
    "StageBinary":{
       "target":{
          "id":"SegomaItemCanvas",
          "width":473,
          "height":375
       },
       "server":{
          "url":"https://ion.r2net.com/",
          "tpl":4,
          "folder":"set/",
          "fileMask":"set",
          "setExt":"txt",
          "lSpeedN":8,
          "lSpeedT":3000,
          "preload":4,
          "simPreloadSets":4,
          "simSets":4,
          "lSimPreloadSets":4,
          "lSimSets":4,
          "dynamic":{
             
          }
       },
       "indicator":{
          "show":true,
          "NSpeedWd":7,
          "LSpeedWd":5,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "LogoImages":",https://ion.r2net.com/Images/Watermark/Watermark4.png",
       "factor":1,
       "autoRotation":true,
       "rotation":true,
       "zoom":true,
       "jsonp":true,
       "MaxSpeedK":1,
       "SlowDownK":1,
       "jsonpClbFnc":"jsonCBF_sis_512_473x375"
    },
    "BrioStageOld":{
       "target":{
          "id":"SegomaItemCanvas",
          "width":473,
          "height":375
       },
       "server":{
          "url":"https://ion.r2net.com/",
          "folder":"",
          "fileMask":"set",
          "setExt":"",
          "setsNum":1,
          "preload":1
       },
       "indicator":{
          "show":false,
          "NSpeedWd":0,
          "LSpeedWd":0,
          "accelK":2
       },
       "bgrColor":"#B5B5B5",
       "ImgBorder":"",
       "invertRotate":true,
       "factor":0.1,
       "autoRotation":true,
       "zoom":false,
       "jsonp":true,
       "jsonpClbFnc":"jsonCBF_Ring_473x375"
    }
 }